<template>
  <div class="d-flex justify-center">
    <img
      alt="Logo"
      :src="logo"
      v-bind="$attrs"
      style="aspect-ratio: 2/1; cursor: pointer"
      transition="scale-transition"
    >
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import LogoDark from "@/assets/logo.dark.svg";
import { useProducersStore } from "@/stores/producers";

defineOptions({
  name: "LogoHeader",
});

const producersStore = useProducersStore();

const logo = computed(() => {
  const producer = producersStore.selected;

  if (producer.id.includes("0")) {
    return LogoDark;
  }

  const id = producer.id[0];

  return `https://storage.torcedordevantagens.com.br/ticket/${id}/logo-dark.svg`;
});
</script>
